import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-product-list-view',
  imports: [],
  templateUrl: './product.list-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
